<p-breadcrumb
  [model]="[
    { label: 'Taxas', routerLink: ['/tax-rates'] },
    {
      label: taxRateId() ? 'Editar Taxa' : 'Nova Taxa',
      routerLink: taxRateId()
        ? ['/tax-rates/update/' + taxRateId()]
        : ['/tax-rates/create'],
    },
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form class="relative" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex justify-between items-center">
      <div>
        @if (taxRateId()) {
          <h5 class="font-bold">Editar Taxa</h5>
          <p>Confira e atualize informações</p>
        } @else {
          <h5 class="font-bold">Cadastrar Nova Taxa</h5>
          <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>

      <div class="flex gap-2">
        <p-button
          label="Cancelar"
          severity="secondary"
          outlined
          routerLink="/tax-rates"
          rounded
        ></p-button>

        <p-button label="Salvar" type="submit" rounded></p-button>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div>
        <label for="country">País *</label>
        <p-select
          inputId="country"
          formControlName="country"
          [options]="countries"
          optionLabel="label"
          optionValue="value"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('country')" />
        <app-form-server-error [control]="formGroup.get('country')" />
      </div>

      <div>
        <label for="state">Estado *</label>
        <p-select
          inputId="state"
          formControlName="state"
          [options]="states"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          placeholder="Selecione o estado"
          class="w-full"
        />
        <app-form-error [control]="formGroup.get('state')" />
        <app-form-server-error [control]="formGroup.get('state')" />
      </div>

      <div>
        <label for="city">Cidade *</label>
        <input
          pInputText
          id="city"
          formControlName="city"
          class="w-full"
          maxlength="255"
          placeholder="Ex: Miami"
        />
        <app-form-error [control]="formGroup.get('city')" />
        <app-form-server-error [control]="formGroup.get('city')" />
      </div>

      <div>
        <label for="rate">Taxa (%) *</label>
        <p-inputNumber
          formControlName="rate"
          inputId="rate"
          mode="decimal"
          locale="en-US"
          suffix=" %"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [min]="0"
          [max]="999.99"
          class="w-full"
          placeholder="Ex: 7.00 %"
        ></p-inputNumber>
        <app-form-error [control]="formGroup.get('rate')" />
        <app-form-server-error [control]="formGroup.get('rate')" />
      </div>
    </div>
  </div>

  @if (loading()) {
    <div
      class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
    >
      <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
    </div>
  }
</form>

<p-toast />
